import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    ViewChild,
    ElementRef,
    OnDestroy,
    ChangeDetectorRef,
    Input,
    HostListener, OnChanges
} from '@angular/core';
import {NgbDropdownConfig} from '@ng-bootstrap/ng-bootstrap';
import {Observable, fromEvent, Subscription} from 'rxjs';

import {AuthService} from '../../services/auth.service';
import {SocialService} from '../../services/social.service';
import {AppComponent} from 'src/app/app.component';
import {Router, NavigationEnd, NavigationStart} from '@angular/router';
import {filter} from 'rxjs/operators';
import {isChildOf} from '../../utilities/html.utilities';
import {Languages} from '../../enums/languages';
import {UsersService} from '../../services/users.service';
import {AuthEventsEmitter} from '../../events/auth.events';
import {MasterService} from '../../services/master.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    providers: [NgbDropdownConfig],
})
export class NavbarComponent implements OnInit, OnDestroy, OnChanges {
    private readonly headerToggledClass: string = 'header-toggled';

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;
    @ViewChild('bottomNavbar') bottomNavbar: ElementRef<HTMLElement>;

    @Input() appComponent: AppComponent;

    facebookProfilePictureUrl: Observable<string>;
    profileImageSrc = '/assets/images/avatar.png';
    languages = Object.keys(Languages).map(k => Languages[k]);
    subscriptions: Subscription[] = [];
    haveMasterProfile = false;
    isDiaryChangeDisabled = false;
    isUserUnderMasterProfile = false;
    isUserOnCatering = false;
    userHasSport = false;

    constructor(
        public readonly config: NgbDropdownConfig,
        public readonly authService: AuthService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly socialService: SocialService,
        private readonly router: Router,
        private readonly usersService: UsersService,
        private readonly authEventsEmitter: AuthEventsEmitter,
        private readonly masterService: MasterService,
    ) {
        config.placement = 'bottom-right';
        this.mutePage();
    }

    ngOnChanges() {
        this.mutePage();
        this.changeDetectorRef.detectChanges();
    }

    mutePage() {
        const elems = document.querySelectorAll('video, audio');

        [].forEach.call(elems, function (elem) {
            elem.muted = true;
            elem.pause();
        });
    }

    ngOnInit() {
        // const containerScroller: HTMLElement = document.querySelector('.container-scroller');
        this.mutePage();

        // check if user is under master profile
        this.masterService.checkIsSubAccountUnderMaster().subscribe(success => {
            this.isUserUnderMasterProfile = true;
        });

        this.usersService.getUserCateringMeals().subscribe(data => {
            this.isUserOnCatering = (data && data.length > 0);
        });

        // Horizontal menu fixed when scrolling
        this.subscriptions.push(
            fromEvent(document.body, 'scroll').subscribe(() => {
                if (document.body.scrollTop >= this.wrapper.nativeElement.offsetHeight) {
                    this.wrapper.nativeElement.classList.add('fixed-on-scroll');
                } else {
                    this.wrapper.nativeElement.classList.remove('fixed-on-scroll');
                }
            })
        );

        this.subscriptions.push(
            this.router.events.pipe(
                filter(e => e instanceof NavigationStart && !!this.bottomNavbar)
            )
                .subscribe(() => {
                    this.bottomNavbar.nativeElement.classList.remove(this.headerToggledClass);
                })
        );

        // Horizontal menu navigation in mobile menu on click
        let navItemClicked = document.querySelectorAll('.horizontal-menu .page-navigation >.nav-item');
        navItemClicked.forEach(function (el) {
            el.addEventListener('click', function () {
                navItemClicked.forEach(function (subel) {
                    subel.classList.remove('show-submenu');
                });

                if (window.matchMedia('(max-width: 991px)').matches) {
                    el.classList.toggle('show-submenu');
                }
            });
        }, false);

        this.subscriptions.push(
            this.router.events.pipe(
                filter(e => e instanceof NavigationEnd)
            )
                .subscribe(() => {
                    this.changeDetectorRef.detectChanges();
                })
        );

        this.usersService.getUserSport().subscribe(sport => {
            this.userHasSport = true;
            this.changeDetectorRef.markForCheck();
        }, () => {
            this.userHasSport = false;
            this.changeDetectorRef.markForCheck();
        });

        if (this.socialService.userIsLoggedInFacebook) {
            this.subscriptions.push(
                this.socialService.getFacebookProfilePictureUrl(this.socialService.facebookId)
                    .subscribe(src => {
                        this.profileImageSrc = src;
                        this.changeDetectorRef.markForCheck();
                    })
            );
        }

        let dis = false;
        this.haveMasterProfile = window.location.href.includes('master');

        if (
            this.authService.getStorageItem('master_sub_profile_logged_token')
            && this.authService.getStorageItem('master_sub_profile_logged_token').length > 0
            && window.location.href.includes('master/meals')
        ) {
            dis = true;

            this.usersService.getMasterUserProfile().subscribe(profile => {
                this.isDiaryChangeDisabled = profile && profile.is_master_profile === false && profile.is_change_diary_disabled === true;

                if (profile && profile.is_master_profile === true) {
                    this.haveMasterProfile = true;
                    this.changeDetectorRef.markForCheck();
                }

                this.changeDetectorRef.markForCheck();
            });
        } else {
            this.usersService.getUserProfile().subscribe(profile => {
                // this.haveMasterProfile = profile && profile.is_master_profile;
                this.isDiaryChangeDisabled = profile && profile.is_master_profile === false && profile.is_change_diary_disabled === true;

                if (profile && profile.is_master_profile === true) {
                    this.haveMasterProfile = true;
                    this.changeDetectorRef.markForCheck();
                }

                this.changeDetectorRef.markForCheck();
            });
        }

        if (dis === false) {
            this.authEventsEmitter.userProfileChanged$
                .subscribe(() => {
                    this.usersService.getUserProfile(true).subscribe(profile => {
                        // this.haveMasterProfile = profile && profile.is_master_profile;
                        this.isDiaryChangeDisabled = profile && profile.is_master_profile === false && profile.is_change_diary_disabled === true;

                        this.changeDetectorRef.markForCheck();
                    });
                });
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    get completeHeader(): boolean {
        return this.appComponent.completeHeader;
    }

    toggleRightSidebar() {
        document.querySelector('.bottom-navbar').classList.toggle('header-toggled');
    }

    onLogout() {
        this.authService.logout();
    }

    onWebChat() {
        document.body.classList.remove('hide-tidio-chat');
        window['tidioChatApi'].open();

        document.addEventListener('tidioChat-close', function () {
            document.body.classList.add('hide-tidio-chat');
        });
    }

    onLanguageSelected(locale: Languages) {
        this.usersService.updateUserProfile({
            locale
        })
            .subscribe(() => {
                window.location.href = this.router.url;
            });
    }

    flagIcon(language: Languages): string {
        switch (language) {
            case Languages.English:
                return 'us';
            default:
                return language.toLowerCase();
        }
    }

    @HostListener('window:click', ['$event'])
    onWindowClick(e: Event) {
        if (!this.wrapper) {
            return;
        }

        if (!this.bottomNavbar) {
            return;
        }

        const target = e.target as HTMLElement;
        const {nativeElement} = this.wrapper;

        if (target !== nativeElement && !isChildOf(nativeElement, target)) {
            this.bottomNavbar.nativeElement.classList.remove(this.headerToggledClass);
        }
    }
}
